import qs from 'qs';
import fetcher from '../../modules/ajio-fetch';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { fetchGetJSONReqOpts, fetchGetJSONResHandler } from '../../modules/ajio-fetch/utils';
import {
  getPriorityDeliveryPhase2Flag,
  getPriorityDeliverySLPTagsConfig,
  getRushDeliveryFlag
} from '../../refresh/selectors/featureFlagsSelector';
import { getPreviousSearchSource } from '../../refresh/selectors/productpage';
import { getStoreName } from '../../modules/ga/GTMdatalayer';
import { showLoader, hideLoader } from './loader';
import { readCookie } from '../../components/common/Cookie';
import { setPlpOnLandingResponse } from '../homeData';
import { getAmplitudeExperimentVariant, getAmplitudeVariantPayload } from '../../utils/amplitudeCommon';
import { sha256Hex } from '../../utils/products';

export function setCurrentFacets(
  facets,
  totalResults,
  isAdvanceFacetsEnabled = '',
  query = {},
  isPriorityDeliveryOffered,
  enablePriorityDeliveryPhase2,
  enableRushDelivery,
  sessionGenderContext = '',
  plpGender = ''
) {
  return {
    type: 'SET_CURRENT_FACETS',
    items: facets,
    totalResults,
    isAdvanceFacetsEnabled,
    query,
    isPriorityDeliveryOffered,
    enablePriorityDeliveryPhase2,
    enableRushDelivery,
    sessionGenderContext,
    plpGender
  };
}

export function setNextFacets(query = {}) {
  return {
    type: 'SET_NEXT_FACETS',
    query
  };
}

export function setCurentFacetsQuery(query = {}) {
  return {
    type: 'SET_CURRENT_FACETS_QUERY',
    query
  };
}

export function clearNextFacets() {
  return {
    type: 'CLEAR_NEXT_FACETS'
  };
}

export function removeFacets(id) {
  return {
    type: 'REMOVE_FACETS',
    id
  };
}

export function nextFacetFetched(items, query = {}, totalResults, id, isPriorityDeliveryOffered) {
  return {
    type: 'NEXT_FACETS_FECHED',
    items,
    query,
    totalResults,
    id,
    isPriorityDeliveryOffered
  };
}

function extractVisitorId(gaValue = '') {
  if(!gaValue) {
    return '';
  }
  const parts = gaValue.split('.');
  if (parts.length >= 4) {
    return parts[2] + '.' + parts[3];
  }
  return '';
}

export async function setDeliveryFacets(
  facets, //all the available facets(sla), delivery(code =sla) is one of the options
  isSlaNodesAvailable, //is any delivery option available or not
  enablePriorityDeliveryPhase2, //flag for PD2
  priorityDeliverySLPTagsConfig, //config for PD2
  enableRushDelivery //flag for RUSH
) {
  const configDeliveryFacets = priorityDeliverySLPTagsConfig?.FILTERS_BUCKET || {};
  const configFacetValues = configDeliveryFacets?.values || [];

  let disabledDeliveryFacets = null;
  let isPriorityDeliveryOffered = false;

  if (enableRushDelivery) {
    if (isSlaNodesAvailable) {
      isPriorityDeliveryOffered = true;
      let deliveryFacets = facets.find(facet => facet.code === 'sla');
      let deliveryFacetValues = deliveryFacets?.values || [];

      // Update delivery facet name based on config
      deliveryFacetValues = deliveryFacetValues.map(deliveryFacet => {
        const configFacet = configFacetValues?.find(
          configFacet => configFacet.code === deliveryFacet.code
        );
        return configFacet
          ? { ...deliveryFacet, name: configFacet.name, priorityId: configFacet.priorityId }
          : deliveryFacet;
      });

      // Sort delivery facets based on priorityId
      deliveryFacetValues.sort((a, b) => (a.priorityId || 0) - (b.priorityId || 0));
      deliveryFacets.values = [...deliveryFacetValues];
      deliveryFacets.topValues = [...deliveryFacetValues];
    } else {
      isPriorityDeliveryOffered = false;
      disabledDeliveryFacets = configDeliveryFacets;
    }
  } else if (enablePriorityDeliveryPhase2) {
    if (isSlaNodesAvailable) {
      isPriorityDeliveryOffered = true;
      let deliveryFacets = facets.find(facet => facet.code === 'sla');
      let deliveryFacetValues = deliveryFacets?.values || [];

      // Merge missing facets from config into delivery facets
      const newDeliveryFacetValues = [];
      configFacetValues.forEach(configFacetValue => {
        const exists = deliveryFacetValues.some(
          deliveryFacetValue => deliveryFacetValue.code === configFacetValue.code
        );

        if (!exists) {
          newDeliveryFacetValues.push(configFacetValue);
        }
      });
      deliveryFacetValues = [...deliveryFacetValues, ...newDeliveryFacetValues];

      // Update delivery facet name based on config
      deliveryFacetValues = deliveryFacetValues.map(deliveryFacet => {
        const configFacet = configFacetValues?.find(
          configFacet => configFacet.code === deliveryFacet.code
        );
        return configFacet
          ? { ...deliveryFacet, name: configFacet.name, priorityId: configFacet.priorityId }
          : deliveryFacet;
      });

      // Sort delivery facets based on priorityId
      deliveryFacetValues.sort((a, b) => (a.priorityId || 0) - (b.priorityId || 0));
      deliveryFacets.values = [...deliveryFacetValues];
      deliveryFacets.topValues = [...deliveryFacetValues];
    } else {
      isPriorityDeliveryOffered = false;
      disabledDeliveryFacets = configDeliveryFacets;
    }
  }
  return { disabledDeliveryFacets, isPriorityDeliveryOffered };
}

export function fetchNextFacets({
  request = {},
  query = {},
  id,
  store = '',
  isRequestFromPlpOnLanding = false
}) {
  return (dispatch, getState) => {
    const states = getState();
    const isVertexCategoryEnabled= getAmplitudeVariantPayload('enableCategoryWidgetsVertex', states, false) && getAmplitudeExperimentVariant('vertex-exp-flag',states);
    const enableSegmentIdVertex= getAmplitudeVariantPayload('enableSegmentIdVertex', states, false);

    const ospreySearch = states?.flags?.enableOspreySearch === 'ON';
    const isVertexSearchEnabled = states?.flags?.vertexEnabled === 'ON';
    const isUserRelevancy = states?.flags?.userRelevancy === 'ON';
    const visitorId = enableSegmentIdVertex ? readCookie('segment_device_id'): extractVisitorId(readCookie('_ga') || '');
    const customerUUID = readCookie('CI') || '';
    const segmentAnonymousId = readCookie('segment_device_id');
    const isLoggedIn = readCookie('LS') === 'LOGGED_IN';

    const storeNameValue = getStoreName();
    const searchStore = storeNameValue === '' || storeNameValue === 'ajio';
    const searchAjioStore =
      storeNameValue === '' || storeNameValue === 'ajio' || storeNameValue === 'rilfnl';
    const isAjioStoreOspreySearch = ospreySearch && searchStore;
    const previousSource = getPreviousSearchSource(states);

    dispatch(showLoader('fetching-next-facets'));
    if (
      request.pathname.includes('/search') &&
      request.query.query &&
      !request.query.query.startsWith(request.freeTextSearch)
    ) {
      request.query.query = `${request.freeTextSearch}${request.query.query}`;
    }

    const pincode = readCookie('PC');
    const rushAvail = readCookie('RushAvail');
    const rushLocationCoords = readCookie('RushLocationCoords');

    const enablePriorityDeliveryPhase2 = getPriorityDeliveryPhase2Flag(states?.flags);
    const priorityDeliverySLPTagsConfig = getPriorityDeliverySLPTagsConfig(states);
    const enableRushDelivery = getRushDeliveryFlag(states);

    const rushLocationCoordsObj = (rushLocationCoords && JSON.parse(rushLocationCoords)) || {};
    const rushAvailObj = (rushAvail && JSON.parse(rushAvail)) || {};
    const { lat = '', long = '' } = rushLocationCoordsObj;
    const { rushDelivery: rushDeliveryAvailability = false } = rushAvailObj;
    const isCategoryPath= request?.pathname?.includes('/category');

    let apiEndPoint = `${request.pathname}?${qs.stringify({
      ...request.query,
      advfilter: true,
      displayRatings: true,
      userEncryptedId: isLoggedIn ? sha256Hex(customerUUID) : sha256Hex(segmentAnonymousId),
      ...(previousSource && isCategoryPath && { previousSource }),
      ...(searchAjioStore && isCategoryPath && { vertexEnabled: isVertexCategoryEnabled && !isUserRelevancy }),
      ...(isVertexCategoryEnabled && !isUserRelevancy && searchAjioStore && visitorId && isCategoryPath && { visitorId }),
    })}`;

    if (
      request.pathname.includes('/search')
    ) {
      apiEndPoint = `${request.pathname}?${qs.stringify({
        ...request.query,
        advfilter: true,
        displayRatings: true,
        userEncryptedId: isLoggedIn ? sha256Hex(customerUUID) : sha256Hex(segmentAnonymousId),
        ...(isAjioStoreOspreySearch && { ospreySearch }),
        ...(previousSource && { previousSource }),
        ...(searchAjioStore && { vertexEnabled: isVertexSearchEnabled }),
        ...(isVertexSearchEnabled && searchAjioStore && visitorId && { visitorId }),
        ...enableRushDelivery && { enableRushDelivery }
      })}`;
    }

    if (
      (enableRushDelivery || enablePriorityDeliveryPhase2) &&
      pincode &&
      !apiEndPoint.includes('pincode=')
    ) {
      apiEndPoint = `${apiEndPoint}&pincode=${pincode}`;
    }

    if (
      enableRushDelivery &&
      rushDeliveryAvailability &&
      lat &&
      long &&
      !apiEndPoint.includes('latitude=') &&
      !apiEndPoint.includes('longitude=')
    ) {
      apiEndPoint = `${apiEndPoint}&latitude=${lat}&longitude=${long}`;
    }

    if (store && !apiEndPoint.includes('store')) {
      apiEndPoint = `${apiEndPoint}&store=${store}`;
    }

    return fetcher(`${apiEndPoint}`, fetchGetJSONReqOpts())
      .then(fetchGetJSONResHandler)
      .then(async serviceRes => {
        const { facets = [], pagination = {}, isSlaNodesAvailable = false } = serviceRes;
        const { totalResults = 0 } = pagination;
        const {
          disabledDeliveryFacets = null,
          isPriorityDeliveryOffered = false
        } = await setDeliveryFacets(
          facets,
          isSlaNodesAvailable,
          enablePriorityDeliveryPhase2,
          priorityDeliverySLPTagsConfig,
          enableRushDelivery
        );
        const updatedFacets = disabledDeliveryFacets ? [...facets, disabledDeliveryFacets] : facets;

        if (isRequestFromPlpOnLanding) {
          const { facets = [], ...responseWithoutFacets } = serviceRes;
          dispatch(
            setPlpOnLandingResponse({
              ...responseWithoutFacets,
              facets: updatedFacets
            })
          );
        }
        dispatch(
          nextFacetFetched(updatedFacets, query, totalResults, id, isPriorityDeliveryOffered)
        );
        dispatch(hideLoader('fetching-next-facets'));
      })
      .catch(err => {
        dispatch(hideLoader('fetching-next-facets'));
        console.log(err);
      });
  };
}

export function clearAllSelectedFacets(items) {
  return {
    type: 'CLEAR_ALL_SELECTED_FACETS'
  };
}
